import { STAT_CATEGORIES } from "./stats";

export const ALL_TIME_GREATS_DEFAULT = {
  category: STAT_CATEGORIES.HITTING,
  stat: "home-runs",
};

const hitting = (key, label, railLabel, extra = {}) => ({
  key,
  category: STAT_CATEGORIES.HITTING,
  label,
  railLabel,
  ...extra,
});

const pitching = (key, label, railLabel, extra = {}) => ({
  key,
  category: STAT_CATEGORIES.PITCHING,
  label,
  railLabel,
  ...extra,
});

const fielding = (key, label, railLabel, extra = {}) => ({
  key,
  category: STAT_CATEGORIES.FIELDING,
  label,
  railLabel,
  ...extra,
});

export const ALL_TIME_GREATS_STATS = {
  "home-runs": hitting("home-runs", "Home runs", "HR"),
  "batting-average": hitting("batting-average", "Batting average", "AVG", {
    minAtBats: 3000,
    qualifier: "Minimum 3,000 career at-bats",
  }),
  rbi: hitting("rbi", "RBI", "RBI"),
  hits: hitting("hits", "Hits", "H"),
  "on-base-percentage": hitting("on-base-percentage", "On-base percentage", "OBP", {
    minAtBats: 3000,
    qualifier: "Minimum 3,000 career at-bats",
  }),
  "slugging-average": hitting("slugging-average", "Slugging percentage", "SLG", {
    minAtBats: 3000,
    qualifier: "Minimum 3,000 career at-bats",
  }),
  runs: hitting("runs", "Runs", "R"),
  doubles: hitting("doubles", "Doubles", "2B"),
  triples: hitting("triples", "Triples", "3B"),
  walks: hitting("walks", "Walks", "BB"),
  strikeouts: hitting("strikeouts", "Strikeouts", "SO"),
  wins: pitching("wins", "Wins", "W"),
  era: pitching("era", "ERA", "ERA", {
    minInnings: 1000,
    qualifier: "Minimum 1,000 innings pitched",
  }),
  "pitching-strikeouts": pitching("pitching-strikeouts", "Strikeouts", "SO"),
  "pitching-walks": pitching("pitching-walks", "Walks", "BB"),
  "hits-allowed": pitching("hits-allowed", "Hits allowed", "H"),
  "earned-runs": pitching("earned-runs", "Earned runs", "ER"),
  "complete-games": pitching("complete-games", "Complete games", "CG"),
  shutouts: pitching("shutouts", "Shutouts", "SHO"),
  saves: pitching("saves", "Saves", "SV"),
  "innings-pitched": pitching("innings-pitched", "Innings pitched", "IP"),
  "home-runs-allowed": pitching("home-runs-allowed", "Home runs allowed", "HR"),
  "fielding-games": fielding("fielding-games", "Games", "G"),
  chances: fielding("chances", "Chances", "TC"),
  putouts: fielding("putouts", "Putouts", "PO"),
  assists: fielding("assists", "Assists", "A"),
  errors: fielding("errors", "Errors", "E"),
  "fielding-percentage": fielding(
    "fielding-percentage",
    "Fielding percentage",
    "FLD%",
    {
      minChances: 1000,
      qualifier: "Minimum 1,000 chances",
    }
  ),
  "range-factor": fielding("range-factor", "Range factor", "RF", {
    minGames: 500,
    qualifier: "Minimum 500 games",
  }),
};

export const ALL_TIME_GREATS_CATEGORIES = [
  { value: STAT_CATEGORIES.HITTING, label: "Hitting" },
  { value: STAT_CATEGORIES.PITCHING, label: "Pitching" },
  { value: STAT_CATEGORIES.FIELDING, label: "Fielding" },
];

export const statsForCategory = (category) =>
  Object.values(ALL_TIME_GREATS_STATS).filter((stat) => stat.category === category);

export const defaultStatForCategory = (category) =>
  statsForCategory(category)[0]?.key || ALL_TIME_GREATS_DEFAULT.stat;

export const getAllTimeGreatsStat = (statKey) =>
  ALL_TIME_GREATS_STATS[statKey] || ALL_TIME_GREATS_STATS[ALL_TIME_GREATS_DEFAULT.stat];

export const buildAllTimeGreatsPath = ({
  stat = ALL_TIME_GREATS_DEFAULT.stat,
  page = 1,
  pageSize = 25,
} = {}) => {
  const config = getAllTimeGreatsStat(stat);
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  if (config.minAtBats) params.set("minAtBats", String(config.minAtBats));
  if (config.minInnings) params.set("minInnings", String(config.minInnings));
  if (config.minChances) params.set("minChances", String(config.minChances));
  if (config.minGames) params.set("minGames", String(config.minGames));
  return `/all-time-greats/${config.key}?${params.toString()}`;
};
